/**
 * getBamAuthConfig - returns a proper formatted auth object containing the token and swid keys.
 * Defaults to null values if id_token and swid values are undefined
 * @param  {boolean} oneIdTokenObject = {} - Object containing both token and swid data
 * @param  {object} passOneIdToken = false - Boolean flag to determine if a oneIdToken was passed
 * @param  {array}  userAuth = [] or array list of user auth types
 * @return {object}
 */
export default function getBamAuthConfig(oneIdTokenObject = {}, passOneIdToken = false, userAuth=[]) {
  let authObject = {
    auth: {
      token: null,
      swid: null,
      userAuth
    }
  };

  if (passOneIdToken === true && typeof oneIdTokenObject === 'object') {
    const { id_token = null, swid = null } = oneIdTokenObject;
    authObject = {...authObject, auth: { token: id_token, swid, userAuth }};
  }

  return authObject;
};



// WEBPACK FOOTER //
// ./app/lib/util/getBamAuthConfig.js